import { FunctionComponent } from 'react'

import styled, { css, useTheme } from 'styled-components'

import IconButton from '@components/Buttons/IconButton'

interface VolumeCTAButtonProps {
  muted: boolean
  onVolumeButtonClick: () => void
}

const StyledIconButton = styled(IconButton)`
  ${({
    theme: {
      colors: { staticBlack },
      utils: { opacity },
    },
  }) => css`
    border-radius: 50%;
    background: ${opacity(staticBlack, '80')};
  `}
`

const VolumeCTAButton: FunctionComponent<VolumeCTAButtonProps> = ({
  muted,
  onVolumeButtonClick,
}) => {
  const theme = useTheme()

  return (
    <StyledIconButton
      ariaLabel="Volume"
      buttonSize={40}
      onClick={onVolumeButtonClick}
      iconName={muted ? 'volume-slash-solid' : 'volume-high-solid'}
      iconSize={20}
      iconColor={theme.colors.staticWhite}
    />
  )
}

export default VolumeCTAButton
